/**
 * Data Import Wizard workspace module.
 *
 * Registers the 'data-import' workspace type (mirrors `cross-engine-migrate/index.ts`).
 * S4.T1 ships a minimal placeholder component; S4.T2 replaces it with the real
 * 4-step stepper (Source/Target/Columns/Import).
 */
import { registerWorkspaceComponent } from '../core/registry/workspaceRegistry';
import { lazyWorkspaceTab } from '../core/registry/lazyWorkspaceTab';

registerWorkspaceComponent(
  'data-import',
  lazyWorkspaceTab(() => import('./DataImportTab').then((m) => ({ default: m.DataImportTab }))),
);
